<template>

<app-view-sheet-field align="center" :demoted-icon="field.type" :is-sticky="isSticky" :is-demoted="isDemoted" :field="field" :filter="filter">

	<template v-if="disparity < 0">-</template><template v-if="disparity > 0">+</template>{{ disparity | abs | round(1, true) }}

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isDemoted'],

	computed: {

		value: function() {

			return (this.isUser) ? this.item.rating.rating : this.item.group.rating_avg

		},

		average: function() {

			return this.item.game.rating_avg

		},

		disparity: function() {

			return this.value - this.average

		}

	}

}

</script>

<style scoped>

.disparity {
    font-size: 18px;
}

</style>